var SupportErrorHelper;

SupportErrorHelper = {
  constructInbentaLoadErrorMessage: function() {
    var Error, errorMessage;
    Error = {
      ErrorType: "InbentaNotLoaded",
      Tagline: Groupon.Support.Tagline || {},
      SubCategory: Groupon.Support.ContentModel.getSubCategory() || {},
      Category: Groupon.Support.ContentModel.getCategory() || {}
    };
    return errorMessage = "Inbenta Content not loaded for : " + (JSON.stringify(Error));
  },
  constructFlexibleContactChannelMissingMessage: function() {
    var Error;
    return Error = {
      ErrorType: "FlexibleContactChannelMissing",
      Tagline: Groupon.Support.Tagline || {},
      SubCategory: Groupon.Support.ContentModel.getSubCategory() || {},
      Category: Groupon.Support.ContentModel.getCategory() || {}
    };
  }
};

module.exports = SupportErrorHelper;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvaGVscGVycy9lcnJvci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9oZWxwZXJzL2Vycm9yLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGtCQUFBLEdBQ0U7RUFBQSxnQ0FBQSxFQUFtQyxTQUFBO0FBQ2pDLFFBQUE7SUFBQSxLQUFBLEdBQ0U7TUFBQSxTQUFBLEVBQVksa0JBQVo7TUFDQSxPQUFBLEVBQVUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxPQUFoQixJQUEyQixFQURyQztNQUVBLFdBQUEsRUFBYyxPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxjQUE3QixDQUFBLENBQUEsSUFBaUQsRUFGL0Q7TUFHQSxRQUFBLEVBQVcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsV0FBN0IsQ0FBQSxDQUFBLElBQThDLEVBSHpEOztXQUlGLFlBQUEsR0FBZSxtQ0FBQSxHQUFtQyxDQUFDLElBQUksQ0FBQyxTQUFMLENBQWUsS0FBZixDQUFEO0VBTmpCLENBQW5DO0VBUUEsNkNBQUEsRUFBZ0QsU0FBQTtBQUM5QyxRQUFBO1dBQUEsS0FBQSxHQUNFO01BQUEsU0FBQSxFQUFZLCtCQUFaO01BQ0EsT0FBQSxFQUFVLE9BQU8sQ0FBQyxPQUFPLENBQUMsT0FBaEIsSUFBMkIsRUFEckM7TUFFQSxXQUFBLEVBQWMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsY0FBN0IsQ0FBQSxDQUFBLElBQWlELEVBRi9EO01BR0EsUUFBQSxFQUFXLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDLFdBQTdCLENBQUEsQ0FBQSxJQUE4QyxFQUh6RDs7RUFGNEMsQ0FSaEQ7OztBQWVGLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
